import React from 'react';
import classNames from 'classnames';

const InputFieldWithSaveButton = ({
  children,
  className,
  saveButtonHandler,
  ...props
}) => {
  const id = `${props.name}-inputFieldWithSaveButton`;
  const buttonClassName =
    props.active === 'false'
      ? 'btn btn-secondary ff-ss fz-base'
      : 'btn btn-default-color ff-ss fz-base';
  const shouldDisable = props.disabled || props.active;
  const setDisable = shouldDisable === 'true';

  return (
    <label htmlFor={id} className={classNames('InputField-label', className)}>
      <input
        {...props}
        id={id}
        className="SidebarModule-input"
        tabIndex="0"
        disabled={setDisable}
        type={props.type}
      />
      <span className="InputField-labelText">{children}</span>
      <button
        disabled={setDisable}
        type="button"
        className={buttonClassName}
        onClick={() => saveButtonHandler(props.inputdata)}
      >
        Save
      </button>
    </label>
  );
};

export default InputFieldWithSaveButton;
